import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseMap: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 7.5C0.5 6.91493 0.840187 6.38325 1.37141 6.13806L7.87141 3.13806C8.25718 2.96002 8.70036 2.95392 9.09088 3.12129L15.4774 5.85837L21.3714 3.13806C21.8359 2.9237 22.3775 2.96081 22.8084 3.2365C23.2393 3.51219 23.5 3.98847 23.5 4.5V16.5C23.5 17.0851 23.1598 17.6168 22.6286 17.8619L16.1286 20.8619C15.7428 21.04 15.2996 21.0461 14.9091 20.8787L8.52259 18.1416L2.62859 20.8619C2.16413 21.0763 1.62246 21.0392 1.19157 20.7635C0.760684 20.4878 0.5 20.0115 0.5 19.5V7.5ZM7.75 4.84616V16.8462L2 19.5V7.5L7.75 4.84616ZM14.75 19.1786V7.17857L9.25 4.82143V16.8214L14.75 19.1786ZM16.25 19.1539V7.15385L22 4.5V16.5L16.25 19.1539Z"
        fill={color}
      />
    </svg>
  );
};
